import { UPDATE_USER, LOADER_FALSE, LOADER_TRUE } from "../actionTypes";

const initialState = {
  user: {},
  loader: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case LOADER_FALSE:
      return {
        ...state,
        loader: false,
      };
    case LOADER_TRUE:
      return {
        ...state,
        loader: true,
      };
    default:
      return state;
  }
};

export default userReducer;
